module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAAJJJREFUOE9jZKACYASbcWDBf6xmMTI3MNjHNhKyB78h+HT//+/I4Jh4AKSEfEMYmA4wOMQ5ohrikAAxkAyAcAnIEFxhg89ghwTGwWDI/2sMDonalLnk/99GBsfkBtTAJDVM/jHoMDglXIUYsm+ePQMTSwMDwz8H4iMH4hXK0gnUK5QZwvRPm8Eu6RrCEOL9gFUlAKVsRA8SHb6aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folderG.png
// module id = 416
// module chunks = 0